import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_CREATE_CERTIFICATE__REQUEST,
  ACTION_CREATE_CERTIFICATE__SUCCESS,
  ACTION_CREATE_CERTIFICATE__FAIL,
  ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS,
} from '../actionTypes';

import { CERTIFICATE_STATUS__PENDING } from '../constants/certificateStatus';


const statusByHostName = (state = {}, action) => {
  switch (action.type) {
    case ACTION_CREATE_CERTIFICATE__SUCCESS:
      return {
        ...state,
        [action.payload.hostName]: CERTIFICATE_STATUS__PENDING,
      };

    case ACTION_LOAD_CERTIFICATE_STATUS__SUCCESS:
      return {
        ...state,
        [action.payload.hostName]: action.payload.status,
      };

    default:
      return state;
  }
};

const isCreating = (state = {}, action) => {
  switch (action.type) {
    case ACTION_CREATE_CERTIFICATE__REQUEST:
      return {
        ...state,
        [action.payload.hostName]: true,
      };

    case ACTION_CREATE_CERTIFICATE__SUCCESS:
    case ACTION_CREATE_CERTIFICATE__FAIL:
      return {
        ...state,
        [action.payload.hostName]: false,
      };

    default:
      return state;
  }
};

export default combineReducers({
  statusByHostName,
  isCreating,
  errors,
});
